/** 混入 函数 */
export const quantityComputationMethods = {
	methods: {
		calculateGoodsAllAdNum : function(data){
			let arr = JSON.parse(data);
			let num = 0;
			arr.forEach(i => {
				num += this.$options.methods.calculateGoodsAdNum(i.items)
			})
			return num
		},
		calculateGoodsAdNum : function(data){
			if(!data){
				return 0
			}
			return data.filter(i => i.labels && i.labels.indexOf('Sponsored') >= 0).length
		},

		calculateGoodsNum : function(data){
			let arr = JSON.parse(data);	
			let num = 0;
			arr.forEach(i => {
				num += i.page_size;
			})
			return num
		},
	}
}


import { api_keyword_getCheckedKeywordsListByAsinId } from '@/components/api/asinKeyword.js'

export const getcheckedKeywordList = {
	data() {
		return {
			checkedKeywordList : []
		}
	},
	methods: {
		addKeywordBtnDisabled(keyword){
			return this.$data.checkedKeywordList.indexOf(keyword.trim()) != -1
		},
		addCheckedFun : function(keyword){
			this.$data.checkedKeywordList.push(keyword)
		},
		loadcheckedKeyword : function(this_,keywordList,asinId,loadingKey = 'loading'){
			this_ = this_ || this 
			if(keywordList.length <= 0){
				return
			}
			// 开启遮罩
			this_.$data[loadingKey] = true
			api_keyword_getCheckedKeywordsListByAsinId(keywordList,asinId).then(res => {
				this_.$data.checkedKeywordList = res.data
				//关闭遮罩
				this_.$data[loadingKey] = false
			}).catch(err => {
				//关闭遮罩
				this_.$data[loadingKey] = false
				this_.F_alertMsg(this_.F_getErrMSg(err,"加载失败"),4)
			})
		},
	}
}